import { Box, BoxProps } from '@material-ui/core';
import { ComponentType } from 'react';

//Enable types for component="" on Box
const generateOveridableBox = function <T>() {
  return Box as ComponentType<BoxProps & T>;
};
export default generateOveridableBox;
